export function getCoords() {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            return resolve(null); // navegador não suporta
        }

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                resolve({
                    lat: pos.coords.latitude,
                    lon: pos.coords.longitude,
                });
            },
            (err) => {
                resolve(null); // ou reject(err) se quiser tratar
            },
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            }
        );
    });
}

export async function isLocationActive() {
    if (!navigator.permissions) {
        return null;
    }
    const result = await navigator.permissions.query({ name: "geolocation" });
    return result.state === 'granted';
}